import { inject, Injectable } from '@angular/core';
import { StorageProvider } from '../../providers/storage/storage';
import { ActiviteEnCours } from './activite-en-cours.service';
import { UserService } from '../../providers/auth/user.service';

@Injectable({
  providedIn: 'root',
})
export class ActiviteEnCoursStorageProvider {
  private storageProvider: StorageProvider = inject(StorageProvider);
  private userService: UserService = inject(UserService);

  private readonly activitesEnPauseListKey: string = 'ACTIVITES_EN_PAUSE_LIST';

  constructor() {}

  async saveActiviteEnCours(activiteEnCours: ActiviteEnCours) {
    await this.storageProvider.set(this.getKeyActiviteEnCours(), activiteEnCours, false);
  }

  async saveActiviteEnPause(activiteEnCours: ActiviteEnCours) {
    await this.storageProvider.set(this.getKeyActiviteEnPause(activiteEnCours.id), activiteEnCours, false);

    await this.addToActivitesEnPauseList(activiteEnCours);
  }

  async getActiviteEnCours(): Promise<ActiviteEnCours> {
    return await this.storageProvider.get(this.getKeyActiviteEnCours(), false);
  }

  async getActiviteEnPause(idActivite: string): Promise<ActiviteEnCours> {
    return await this.storageProvider.get(this.getKeyActiviteEnPause(idActivite), false);
  }

  async removeActiviteEnCours() {
    await this.storageProvider.remove(this.getKeyActiviteEnCours());
  }

  async supprimerActiviteEnPause(id: string) {
    await this.storageProvider.remove(this.getKeyActiviteEnPause(id));
    await this.removeFromActivitesEnPauseList(id);
  }

  private getKeyActiviteEnCours() {
    const idUser = this.userService.getId();
    return 'ACTIVITE_EN_COURS_' + idUser;
  }

  private getKeyActiviteEnPause(idActivite: string) {
    return 'ACTIVITE_EN_PAUSE_' + idActivite;
  }

  private async addToActivitesEnPauseList(activiteEnCours: ActiviteEnCours) {
    let activitesEnPause: string[] = await this.storageProvider.get(this.activitesEnPauseListKey, false);
    if (activitesEnPause == null) {
      activitesEnPause = [];
    }
    if (activitesEnPause.indexOf(activiteEnCours.id) === -1) {
      activitesEnPause.push(activiteEnCours.id);
      await this.storageProvider.set(this.activitesEnPauseListKey, activitesEnPause, false);
    }
  }

  private async removeFromActivitesEnPauseList(idActivite: string) {
    let activitesEnPause: string[] = await this.storageProvider.get(this.activitesEnPauseListKey, false);
    if (activitesEnPause == null) {
      return;
    }
    const index = activitesEnPause.indexOf(idActivite);
    if (index > -1) {
      activitesEnPause.splice(index, 1);
      await this.storageProvider.set(this.activitesEnPauseListKey, activitesEnPause, false);
    }
  }

  async getIdsActivitesEnPauseOuEnCours(): Promise<string[]> {
    let ids: string[] = [];

    const idsActivitesEnPause = await this.storageProvider.get(this.activitesEnPauseListKey, false);
    if (idsActivitesEnPause != null) {
      ids = ids.concat(idsActivitesEnPause);
    }
    const activiteEnCours = await this.getActiviteEnCours();
    if (activiteEnCours != null) {
      ids = ids.concat(activiteEnCours.id);
    }
    return ids;
  }
}
